import 'es6-promise/auto';
import $ from 'jquery';
import {
    version as _version,
    config as _config,
    setRuntimeConfig,
    setDefaultConfig
} from './core';
import { retrieve, assign, getUwrResourcePath } from './util';
import '../widgets/Common/js/common';
import * as _advancedDropdown from '../widgets/AdvancedDropdown/js/advancedDropdown';
import * as _dropdown from '../widgets/Dropdown/js/dropdown';
import * as _modalDialog from '../widgets/ModalDialog/js/modalDialog';
import * as _tooltip from '../widgets/Tooltip/js/tooltip';
import '../widgets/Button/js/button';
import '../widgets/ButtonContainer/js/buttonContainer';
import * as _defaultButton from '../widgets/DefaultButton/js/defaultButton';
import '../widgets/Link/js/link';
import * as _segmentedControl from '../widgets/SegmentedControl/js/segmentedControl';
import * as _tile from '../widgets/Tile/js/tile';
import * as _timer from '../widgets/Timer/js/timer';
import '../widgets/LoadingMessage/js/loadingMessage';
import * as _localNavigation from '../widgets/LocalNavigation/js/localNavigation';
import * as _singleCheckbox from '../widgets/SingleCheckbox/js/singleCheckbox';
import * as _datePicker from '../widgets/DatePicker/js/datePicker';
import * as _shifterBox from '../widgets/ShifterBox/js/shifterBox';
import * as _slider from '../widgets/Slider/js/slider';
import * as _input from '../widgets/Input/js/input';
import formatDate from '../widgets/Common/js/formatter/dateFormatter';
import formatNumber from '../widgets/Common/js/formatter/numberFormatter';
import * as _messageBox from '../widgets/MessageBox/js/messageBox';
import overlayDefault, * as _overlay from '../widgets/Overlay/js/overlay';
import '../widgets/RadioButton/js/radioButton';
import '../widgets/Checkbox/js/checkbox';
import * as _tabControl from '../widgets/TabControl/js/tabControl';
import * as _processNavigation from '../widgets/ProcessNavigation/js/processNavigation';

// Set webpack publicPath on the fly. This is not a hack!
// This is the officially documented way. See: https://webpack.js.org/guides/public-path/#set-value-on-the-fly
/* eslint-disable */
__webpack_public_path__ = getUwrResourcePath() + '/';
/* eslint-enable */

export var version = _version;
export var config = _config;

config.require = {
    baseUrl: getUwrResourcePath(),
    paths: {
        'uwr/highcharts/mapdata/custom/world-lowres': 'external/highcharts-4.2.3/mapdata/custom/world-lowres.amd',
        'uwr/highcharts/mapdata/custom/world-highres': 'external/highcharts-4.2.3/mapdata/custom/world-highres.amd',
        'uwr/highcharts/mapdata/custom/world-custom': 'shared/mapdata/custom/world-custom.amd'
    }
};

/**
 * Registers a global widget onready handler that will be invoked if all widgets got initialized on the page.
 * If they are not initialized yet then the execution of all the already registered handlers will be deferred
 * till the initialization is finished.
 */
export function init(callback) {
    $(function () {
        _advancedDropdown.init();
        _datePicker.init();
        _defaultButton.init();
        _dropdown.init();
        _input.init();
        _localNavigation.init();
        _messageBox.init();
        _modalDialog.init();
        _overlay.init();
        _processNavigation.init();
        _segmentedControl.init();
        _shifterBox.init();
        _singleCheckbox.init();
        _slider.init();
        _tabControl.init();
        _tile.init();
        _timer.init();
        _tooltip.init();
        if (typeof callback === 'function') {
            callback();
        }
    });
}
export var ready = init;

function mainInit() {
    var initType = _config('init');

    initType = typeof initType !== 'undefined' ? initType : 'auto';

    if (initType === 'auto') {
        init();
    }
}

setRuntimeConfig();
$(function () {
    setDefaultConfig();

    // Prepare Modal Dialogs' contents then init all widgets.
    if (retrieve('uwr.modaldialog') && !retrieve('uwr._runtime.modalDialog.prepared')) {
        retrieve('uwr.modaldialog').prepare(mainInit);
        assign('uwr._runtime.modalDialog.prepared', true);
    } else {
        mainInit();
    }
});


function buildApi(widget, functions, target) {
    target = target || {};
    return functions.reduce(function (api, functionName) {
        api[functionName] = widget[functionName];
        return api;
    }, target);
}

/**
 * Calls the parameter function with one argument, the jQuery object.
 */
function jquery(cb) {
    if (typeof cb === 'function') {
        cb($);
    }
}
export var util = {
    jquery: jquery
};

assign('$uwr', $);

if (_config('jquery') === 'public') {
    // $uwr is available here only in the standalone build (which means a synchronous UW4)!
    window.$ = $;
    window.jQuery = $;
}

export var advanceddropdown = buildApi(_advancedDropdown, ['init', 'setValue', 'ready', 'enable', 'disable', 'reset']);

/**
 * Calls the parameter function with two arguments, the Highcharts object and UWR's jQuery. Highcharts is
 * loaded on demand using webpack Code Splitting - Async feature.
 * See https://webpack.js.org/guides/code-splitting-async/
 */
export function highcharts(cb) {
    import(/* webpackChunkName: "highcharts" */ '../widgets/Chart/js/highchartsUbsTheme').then(function (Highcharts) {
        window.Highcharts = Highcharts.default;

        if (typeof cb === 'function') {
            cb(Highcharts.default, $);
        }
    });
}

export var formatter = {
    date: { format: formatDate },
    number: { format: formatNumber }
};
export var datepicker = buildApi(_datePicker, ['init']);
export var defaultbutton = buildApi(_defaultButton, ['init']);
export var dropdown = buildApi(_dropdown, ['init']);
export var input = buildApi(_input, ['init', 'message']);
export var localnav = buildApi(_localNavigation, ['deselect', 'disable', 'enable', 'hide', 'init', 'select', 'show']);
export var messagebox = buildApi(_messageBox, ['init']);
export var modaldialog = buildApi(_modalDialog, ['init', 'open', 'close', 'invoke', 'prepare']);
export var overlay = buildApi(_overlay, ['init', 'hide', 'show'], overlayDefault);
export var procnav = buildApi(_processNavigation, ['init', 'active', 'complete', 'next', 'back']);
export var segmentedcontrol = buildApi(_segmentedControl, ['init', 'toggle']);
export var shifterbox = buildApi(_shifterBox, ['init', 'getState']);
export var singlecheckbox = buildApi(_singleCheckbox, ['init', 'setChecked', 'setType', 'toggle']);
export var slider = buildApi(_slider, ['init']);
export var tabcontrol = buildApi(_tabControl, ['init']);
export var tile = buildApi(_tile, ['init']);
export var timer = buildApi(_timer, ['init', 'start', 'cancel', 'ready']);
export var tooltip = buildApi(_tooltip, ['init', 'enable', 'disable']);



//////////////////
// WEBPACK FOOTER
// ./loader/index.js
// module id = 80
// module chunks = main